/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/index'
import mHome from '@/pages/mobile/index'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/coupon',
			name: 'Index',
			component: Home
		},
		{
			path: '/coupon',
			name: 'mIndex',
			component: mHome
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js